import React, { useState } from 'react';
import styles from './Accounts.module.css';

// Searchable checkbox list of students, used wherever a parent account is
// linked to its children.
function StudentPicker({ students, selectedIds, onChange, loading }) {
  const [search, setSearch] = useState('');

  const toggle = (id) => {
    onChange(selectedIds.includes(id) ? selectedIds.filter((s) => s !== id) : [...selectedIds, id]);
  };

  const term = search.trim().toLowerCase();
  const visible = students
    .filter((s) => !term || s.full_name?.toLowerCase().includes(term) || s.class_name?.toLowerCase().includes(term))
    .sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''));

  return (
    <div className={styles.picker}>
      <input
        type="search"
        className={styles.pickerSearch}
        placeholder="Search students by name or class…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        aria-label="Search students"
      />
      <div className={styles.pickerList}>
        {loading ? (
          <div className={styles.pickerEmpty}>Loading students…</div>
        ) : visible.length === 0 ? (
          <div className={styles.pickerEmpty}>{term ? 'No students match that search.' : 'No students found.'}</div>
        ) : (
          visible.map((student) => (
            <label key={student.id} className={styles.pickerRow}>
              <input type="checkbox" checked={selectedIds.includes(student.id)} onChange={() => toggle(student.id)} />
              <span className={styles.pickerName}>{student.full_name}</span>
              <span className={styles.pickerMeta}>{[student.class_name, student.stream].filter(Boolean).join(' ') || 'No class'}</span>
            </label>
          ))
        )}
      </div>
      <div className={styles.pickerCount}>{selectedIds.length} selected</div>
    </div>
  );
}

export default StudentPicker;
